export class TokenUtils {
	static decodeToken(rawToken) {
		if (!rawToken || rawToken === 'undefined') return null;

		try {
			const base64Url = rawToken.split('.')[1];
			const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));

			return JSON.parse(jsonPayload);
		} catch (error) {
			return null;
		}
	}

	static hasValidSession() {
		const token = this.decodeToken(sessionStorage.getItem('token'));
		const sessionToken = this.decodeToken(sessionStorage.getItem('session_token'));

		return Boolean(token && sessionToken && sessionToken.exp && sessionToken.exp * 1000 > Date.now());
	}

	static extractLabsFromToken() {
		const token = sessionStorage.getItem('token');
		if (!token) return [];

		try {
			const base64Url = token.split('.')[1];
			const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));

			const jwt = JSON.parse(jsonPayload);

			return jwt.laboratorios || [];
		} catch (error) {
			console.error('Erro ao extrair laboratórios do token:', error);
			return [];
		}
	}

	static getTokenData() {
		const token = sessionStorage.getItem('token');
		if (!token) return null;

		try {
			const base64Url = token.split('.')[1];
			const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));

			return JSON.parse(jsonPayload);
		} catch (error) {
			console.error('Erro ao decodificar token:', error);
			return null;
		}
	}

	static hasModuloMidiaLabs() {
		const tokenData = this.getTokenData();
		if (!tokenData || !tokenData.modulos) return false;

		return tokenData.modulos.includes('Midia LABs');
	}

	static hasModuloLentePronta() {
		const tokenData = this.getTokenData();
		if (!tokenData || !tokenData.modulos) return false;

		return tokenData.modulos.includes('Lente Pronta');
	}

	static hasModuloSimulador() {
		const tokenData = this.getTokenData();
		if (!tokenData || !tokenData.modulos) return false;

		return tokenData.modulos.includes('Pacto Simulador');
	}

	static hasModuloRepondeur() {
		const tokenData = this.getTokenData();
		if (!tokenData || !tokenData.modulos) return false;

		return tokenData.modulos.includes('Conecta Responde');
	}

	static hasModuloPactoAdminSimulador() {
		const tokenData = this.getTokenData();

		if (!tokenData || !tokenData.modulos) {
			return false;
		}

		return tokenData.modulos.some(module => {
			return module === "Pacto Admin" ||
				String(module).startsWith("Pacto Admin.");
		});
	}

	static getUserCnpj() {
		const tokenData = this.getTokenData();

		if (!tokenData || !tokenData.conta) {
			return false;
		}

		return tokenData.conta;
	}

	static getRole() {
		const tokenData = this.getTokenData();

		if (!tokenData || !tokenData.papelCategoria) {
			return false;
		}

		return tokenData.papelCategoria;
	}

	static isEssilor() {
		const role = this.getRole();

		if (!role) {
			return false;
		}

		return role  === "ESSILOR";
	}

	static hasModuloDashboard() {
		const tokenData = this.getTokenData();
		if (!tokenData || !tokenData.modulos) return false;

		return tokenData.modulos.includes('Pacto Dashboard');
	}

	static hasModuloPactoApproval() {
		const tokenData = this.getTokenData();
		if (!tokenData || !tokenData.modulos) return false;

		return tokenData.modulos.includes('Pacto Approval');
	}
}